import { gql } from '@apollo/client';

export const ASSETS_BY_RISK_CATEGORY = gql`
  query metrics {
    metrics {
      assetsByRiskCategory {
        status
        count
      }
    }
  }
`;

export const ASSETS_BY_STATUS = gql`
  query metrics($args: AssetsByStatusInput) {
    metrics {
      assetsByStatus(args: $args) {
        status
        count
      }
    }
  }
`;

export const ASSETS_COUNT = gql`
  query metrics($args: AssetsCountInput) {
    metrics {
      assetsCount(args: $args) {
        count
      }
    }
  }
`;

export const FILES_COUNT = gql`
  query metrics($args: FilesCountInput) {
    metrics {
      filesCount(args: $args) {
        count
      }
    }
  }
`;

export const VULNERABILITIES_COUNT = gql`
  query metrics($args: VulnerabilitiesCountInput) {
    metrics {
      vulnerabilitiesCount(args: $args) {
        count
      }
    }
  }
`;

export const BY_RISK_CATEGORY = gql`
  query assetsByRiskCategory($args: AnalyticsOrgInput) {
    analytics {
      assetsByRiskCategory(args: $args) {
        fields {
          name
          value
        }
      }
    }
  }
`;

export const HIGH_PROFILE_VULNERABILITIES = gql`
  query highProfileVulnerabilities($args: AnalyticsOrgInput) {
    analytics {
      highProfileVulnerabilities(args: $args) {
        uniqueExploits
        associatedCves
        affectedAssets
      }
    }
  }
`;

export const KNOWN_EXPLOITED_VULNERABILITIES = gql`
  query knownExploitedVulnerabilities($args: AnalyticsOrgInput) {
    analytics {
      knownExploitedVulnerabilities(args: $args) {
        uniqueKevs
        pastDue
        affectedAssets
      }
    }
  }
`;

export const SSVC_CATEGORIZATION_SUMMARY = gql`
  query ssvcCategorizationSummary($args: AnalyticsOrgInput) {
    analytics {
      ssvcCategorizationSummary(args: $args) {
        kevActiveAutomatableTotal
        activeAutomatableTotal
        activeAutomatablePartial
      }
    }
  }
`;

export const SSVC_CATEGORIZATION = gql`
  query ssvcCategorization($args: AnalyticsAssetInput!) {
    analytics {
      ssvcCategorization(args: $args) {
        automatable
        automatableTotal
      }
    }
  }
`;

export const HIGH_PROFILE_VULNERABILITIES_DETAILS = gql`
  query highProfileVulnerabilitiesDetails($args: HighProfileExploitInput!) {
    analytics {
      highProfileExploits(args: $args) {
        edges {
          node {
            category
            name
            associatedCvesCount
            associatedAssetsCount
          }
        }
      }
    }
  }
`;

export const VULNS_SUMMARY_COUNT = gql`
  query vulnerabilitiesSummaryCount($args: AnalyticsAssetInput!) {
    analytics {
      vulnerabilitiesSummaryCount(args: $args) {
        critical
        high
        medium
        low
      }
    }
  }
`;

export const CRYPTOGRAPHY_COUNT = gql`
  query cryptographyCount($args: AnalyticsAssetInput!) {
    analytics {
      cryptographyCount(args: $args) {
        certificates
        invalidCertificates
        publicKeys
        privateFoundInPublic
        privateKeys
        publicFoundInPrivate
      }
    }
  }
`;

export const VULNERABILITIES_OF_INTEREST = gql`
  query vulnerabilitiesOfInterest($args: AnalyticsOrgInput) {
    analytics {
      vulnerabilitiesOfInterest(args: $args) {
        name
        occurrences
        uniques
      }
    }
  }
`;

export const VULNERABILITIES_BY_AGE = gql`
  query vulnerabilitiesByAge($args: AnalyticsOrgInput) {
    analytics {
      vulnerabilitiesByAge(args: $args) {
        ageGroupId
        from
        to
        age
        severity
        count
        uniqueCount
      }
    }
  }
`;

export const VULNERABILITIES_OVERVIEW = gql`
  query vulnerabilitiesOverview($args: VulnerabilityOverviewInput!) {
    vulnerabilitiesOverview(args: $args) {
      pageInfo {
        totalCount
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          cve
          component
          occurrences
          inAssets
          cisaDueDate
          inBotnets
          inKnownAttacks
          inRansomware
          inTheWild
          inThreatActors
          inKnownExploitedVulnerabilities
          dateAdded
          netrisePriorityRating
          severity
          knownAttacksList
          threatActorsList
          botnetsList
          epssScore
          epssPercentile
          exploitFound
          priority
          cvssScore
        }
      }
    }
  }
`;

export const VULNERABILITIES_BY_PRIORITY_RATING = gql`
  query vulnerabilitiesByPriorityScore($args: AnalyticsOrgInput) {
    analytics {
      vulnerabilitiesByPriorityScore(args: $args) {
        priorityScore
        priorityScoreFilter
        occurrences
        uniques
      }
    }
  }
`;

export const MISCONFIGURATION_BY_CATEGORY = gql`
  query misconfigurationByCategory($args: AnalyticsAssetInput!) {
    analytics {
      misconfigurationByCategory(args: $args) {
        category
        passed
        failed
        notApplicable
      }
    }
  }
`;
export const KNOWN_EXPLOITS = gql`
  query knownExploits($args: AnalyticsAssetInput!) {
    analytics {
      knownExploits(args: $args) {
        inKnownExploitedVulnerabilities
        totalWeaponized
        totalReachable
        totalPoc

        totalActors
        totalAttacks
        totalBotnets
        totalRansomware
        exploitCode

        pocTotalActors
        pocTotalAttacks
        pocTotalBotnets
        pocTotalRansomware
        pocTotalExploitCode

        weaponizedTotalActors
        weaponizedTotalAttacks
        weaponizedTotalBotnets
        weaponizedTotalRansomware
        weaponizedTotalExploitCode
      }
    }
  }
`;

export const LICENSES = gql`
  query licenses($args: AnalyticsAssetInput!) {
    analytics {
      licenses(args: $args) {
        license
        count
      }
    }
  }
`;

export const MISCONFIGURATION_CHECK = gql`
  query misconfigurationCheck($args: AnalyticsAssetInput!) {
    analytics {
      misconfigurationCheck(args: $args) {
        passed
        failed
        notApplicable
      }
    }
  }
`;

export const VULNERABILITIES_HIGHLIGHTED_PRODUCTS = gql`
  query vulnerabilityHighlightedProducts($args: AnalyticsAssetHighlightedProductsInput!) {
    analytics {
      vulnerabilityHighlightedProducts(args: $args) {
        product
        vulnerabilities {
          critical
          high
          medium
          low
        }
      }
    }
  }
`;

export const GET_VULNS_FUNNEL_CHART = gql`
  query vulnerabilitiesFunnelChart($args: VulnerabilitiesFunnelChartInput) {
    analytics {
      vulnerabilitiesFunnelChart(args: $args) {
        category
        critical
        high
        medium
        low
        total
      }
    }
  }
`;
